<template>
  <a-layout-header class="header">
  			<a-row>
  				<a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="logo-div" >
  					<img  src="@/assets/img/login/login-logo.png" alt="" />
  					<h1>防汛通</h1>
					<template v-if="isShowLeftSiderDiv==true">
						<template v-if="navShow==true">  
							<a-button shape="circle"  @click="navShowChange" >
							    <img src="@/assets/img/main/header-double-L-arrow-icon.png" />
							</a-button>
						</template>
						<template v-else> 
							<a-button shape="circle"  @click="navShowChange" >
							    <img src="@/assets/img/main/header-double-R-arrow-icon.png" />
							</a-button>
						</template>
					</template>
  				</a-col>
  				<a-col :xs="14" :sm="14" :md="13" :lg="13" :xl="13" class="searchfrom-div" :class="searchfromActive" > 	
						<transition name="fadeLeft" >
						<template v-if="searchfromActive=='active'">
						<ul>
							<li class="search-tip">
								<img  src="@/assets/img/main/icon-search.png" />  搜索
							</li>
							<li class="search-input">
								<input type="search" class="input-txt" placeholder="请输入关键词搜索"  v-model="keywordsVal" @keyup.enter="handleEnter" @input="handleSearch" /> 
								<a-icon type="close-circle" class="icon-close" :class="showCloseIcon" @click="closeInputTxt()" />
							</li>
						</ul>
						</template>
						</transition> 
  				</a-col>
  				<a-col :xs="4" :sm="4" :md="5" :lg="4" :xl="4" class="userinfrom-div" > 
  					<ul>
  						<li class="search-li"  @click="showSearch()">
							<template v-if="isShowSearchDiv==false">
								<img  src="@/assets/img/main/icon-search.png" />								
							</template> 
							<template v-else>
								<span>取消搜索</span>								
							</template> 
  						</li>
  						<li class="home-li">
  							 <img :src="homeImgSrc" @click="tohome()" /> 
  						</li>
  						<headTx></headTx>
  						<li class="userinform-imgdiv" :class="showVal" @click.stop="showbutton()">							
							<template v-if="userid>0"> 								
								<!-- <a-avatar :src="userinfor.avatar" class="user-avatar" /> --> 	
								<a-avatar src="/assets/img/img-p.png" /> 
							</template>
							<template v-else>
								<a-avatar src="/assets/img/img-p.png" />  
							</template>
							<dl ref="targetElement">
								 <dd @click="loginout()">
									<a-icon type="import" /> <span>退出登录</span>
								 </dd>
							 </dl>
							 <!-- <div class="tcbk"></div> -->
  						</li>
  					</ul>
  				</a-col>
  			</a-row>      
  </a-layout-header>
</template>

<script> 

import _ from 'lodash';
import { mapActions } from 'vuex';
import headTx from "./tx.vue";
import storage from 'store';
import {findById,findParentPath,modifyNestedArrayById,modifyNestedArrayByKeyName,findByIdNumber} from '@/utils/util';
export default {
  data() {
    return {
       showVal:"",
	   searchfromActive:"",
	   isShowSearchDiv:false,
	   isShowLeftSiderDiv:true,
	   showCloseIcon:"",//active
	   keywordsVal:"",
	   homeImgSrc:"/assets/img/main/icon-home.png",
	   navShow:true, 
	   userid:0,
	   userinfor:{},
	   menulist:[],
    };
  },
  components: {
    headTx
  },
  computed:{
	  useridVal(){
		  return this.$store.state.user.userid;
	  },
	  userinforVal(){
		  return this.$store.state.user.info;
	  }
  },
  watch:{
	  // 使用watch来监听 响应数据的变化
	  useridVal(newVal)
	  {
		  this.userid=newVal;
	  },
	  userinforVal(newVal)
	  {
		  this.userinfor=newVal;
	  },
	  keywordsVal(newVal, oldVal) {
		//console.log('最新值是：'+newVal,"原来的值是："+ oldVal);
		this.keywordsVal=newVal; 
		//this.$store.commit("article/SetSearchKeyWords",newVal.trim());
		if(newVal.length>0)
		{
			this.showCloseIcon="active";
			this.$store.commit("article/SetSearchKeyWords",newVal);
			this.$store.commit("article/SetSearchKeyWordsTop",newVal);
			//this.$router.push({path:'/search',query:{ks:newVal}});
			//this.changeTxt();
		}
	  }, 
  }, 
  props: {
	  //接受父组件传值
      //message: String // 定义一个名为message的prop，类型为String
	  isShowSearchDivVal:Boolean, 
	  isShowLeftSiderVal:Boolean,
  },
  activated() {
    console.log('header2-页面被激活')
	  this.initV();
  },
  deactivated() {
    console.log('header2-页面被缓存')
  },
  created() {	 
	  this.initV();
  },
  mounted(){
	  //页面初始化
	  if(this.isShowSearchDivVal==true)
	  {
		  this.isShowSearchDiv=true;
		  this.searchfromActive="active";
	  }
	  
	  if(this.isShowLeftSiderVal==false)
	  {
		  this.isShowLeftSiderDiv=false;
	  }
	  var ksVal = this.$route.query.ks; // 'paramName'是你想要获取的参数名
	  if(ksVal!=undefined)
	  {
		 this.$store.commit("article/SetSearchKeyWords",ksVal);
		 this.$store.commit("article/SetSearchKeyWordsTop",ksVal);
		 this.keywordsVal=ksVal;
	  } 
	  else{
		  ksVal=this.$store.state.article.searchKeyWordsTop; 
	  }
	  //console.log("head,---------------------searchKeyWordsTop:",this.$store.state.article.searchKeyWordsTop);
	  
	  this.handleSearch = this.handleSearch.bind(this); // 确保handleSearch中的this指向Vue实例
	  // 初始化时绑定handleSearch到组件实例上，确保在组件销毁时取消防抖函数
	  this.handleSearch = _.debounce(this.performSearch, 1000);
  }, 
  methods: { 	  
	  //响应事件
     ...mapActions(['Logout','GetInfo','SetNextLogin']),
	 initV(){
		 
		 	var _self=this;
		 	var token=this.$store.state.user.token; 
		 	console.log("header2---created:---------------------------info:");
		 	if(token!="")
		 	{
		 		//console.log("user:---------------------------",this.$store.state.user.info);
		 		var info=storage.get("userinfor");
		 		//console.log("user:---------------------------info:",info);
		 		if(info!=undefined)
		 		{
		 			_self.userid=info.id;
		 			_self.userinfor=info;
		 		}
		 		else
		 		{
		 			this.GetInfo().then(res=>{
		 				if(res.errcode===0)
		 				{
		 					console.log("GetInfo:",res);
		 					_self.userid=res.datas.id;
		 					_self.userinfor=res.datas;
		 					//console.log("user:---------------------------",_self.userinfor);
		 				}
		 			}); 			
		 		}		
		 		//_self.userid=this.$store.state.user.userid;
		 		//_self.userinfor=this.$store.state.user.info;
		 	}   
		 	
		 	this.homeImgSrc="/assets/img/main/icon-home.png";
		 	if(this.$route.path=="/main")
		 	{
		 		this.homeImgSrc="/assets/img/main/icon-home-1.png";
		 		this.keywordsVal="";
		 		this.isShowSearchDiv=false;
				this.searchfromActive="";
		 		this.$store.commit("article/SetSearchKeyWords","");
		 		this.$store.commit("article/SetSearchKeyWordsTop","");
		 	}
		 	
		 	this.menulist=_self.$store.state.article.menuList;
		 	if(this.menulist.length<=0)
		 	{
		 		this.$store.dispatch("article/GetMenuList").then(res=>{
		 			this.menulist=_self.$store.state.article.menuList;
		 		});
		 	}
		 	
	 },
	  //菜单是否显示
	  navShowChange(){
		  if(this.navShow==true)
		  {
			  this.navShow=false;
		  }
		  else{
			  this.navShow=true;
		  }
		  this.$emit('navbtn-event', this.navShow);//this.$emit('事件名',要传的数据)
		  return false;
	  },
	  
	   handleSearch: _.debounce(function() {
		   this.performSearch();		   
	   },1000), // 延迟500毫秒执行搜索操作
	   performSearch()
	   {	   	
			var _self=this;
			var keywords=_self.keywordsVal.trim();
			//console.log("keywords:",keywords);			
			if(keywords.length>0)
			{
				this.$store.commit("article/SetSearchKeyWordsTop",keywords.trim());
				this.$router.push({path:'/search',query:{ks:keywords}});
			}
	   },
	    
	   
	  changeTxt(){
		 var keywords=this.keywordsVal.trim(); 
		 if(keywords.length>0)
		 {
			this.$store.commit("article/SetSearchKeyWordsTop",keywords.trim());
			//console.log("keywords:",keywords);
		 	//this.$router.push({path:'/search',query:{ks:keywords}});//
			//this.keywordsVal="";
		 }
	  },
	  handleEnter(){
		  var keywords=this.keywordsVal.trim();
		  if(keywords.length>0)
		  {
			this.$store.commit("article/SetSearchKeyWordsTop",keywords.trim());
			this.$router.push({path:'/search',query:{ks:keywords}});
		  }
		  
	  },
	  closeInputTxt(){
		   this.showCloseIcon="";
		   this.keywordsVal="";
		   this.$store.commit("article/SetSearchKeyWordsTop",this.keywordsVal);
		   //this.$router.push({path:'/main'});//
	  },
	  showSearch(){
		  if(this.isShowSearchDiv==false)
		  {
			  this.isShowSearchDiv=true;
			  this.searchfromActive="active";
			  //this.$store.commit("article/set_seltMenuItem",null);
		  }
		  else{
			this.isShowSearchDiv=false;
			this.searchfromActive="";
			this.$store.commit("article/SetSearchKeyWordsTop",this.searchfromActive);
			this.$router.push({path:'/main'});
			 //this.$store.commit("article/SetSearchKeyWordsTop","");
		  }
	  },
	  showbutton(){ 
		  if(this.showVal=="")
		  {
			  this.showVal="active";
			  this.$nextTick(() => {
				document.addEventListener('click', this.handleClickOutside)
			  })
		  }
		  else
		  {
			  this.showVal="";
		  }
	  },	  
	  handleClickOutside(event) {
		if (!this.$refs.targetElement?.contains(event.target)) {
		  this.showVal = "";
		  //console.log("handleClickOutside-----------------------------");
		  document.removeEventListener('click', this.handleClickOutside)
		}
	  },
		  
		  
	
	tohome(){	  
		  if(navigator.onLine==false)
		  {
			  this.$message.error("网络断开");
			  return;
		  }
		  var _self=this;
		  _self.homeImgSrc="/assets/img/main/icon-home-1.png"; 
		  
		  this.keywordsVal="";
		  this.isShowSearchDiv=false;
		  this.$store.commit("article/SetSearchKeyWords","");
		  this.$store.commit("article/SetSearchKeyWordsTop","");
		  
		  //this.$store.commit('article/SetActiveDetailContent',"div1");
		  //this.$store.commit('article/set_isFenPing',false);	
		  //this.$store.commit("article/set_seltArtItem",[]);
		  //this.$store.commit("article/set_seltArtItem2",[]);
		  
		  //this.$store.commit("article/set_seltMenuItem",{id:id,name:arr.name});
		  var vall=this.$store.state.article.seltMenuItem;
		  console.log("tohome----seltMenuItem:",vall);
		  
		  ///console.log("tohome----menulist:",menulist);
		  this.$store.dispatch("article/getHomeAction").then(res=>{
				
			    var arr=findById(this.menulist,res.datas.id); 
				console.log(res.datas.id);
				console.log(this.menulist);
				var params={
					id:arr.id,//this.$store.state.article.seltMenuItem
					page:1,
					pageSize:this.$store.state.article.pageSize, 
					istype:"curpage"
				};
				_self.$store.dispatch("article/GetArticleList",params).then(res2=>{
					
					this.$store.commit("article/set_defaultMenuItem",{id:arr.id,name:arr.name});					
					var pplist=findParentPath(this.menulist,arr.id);
					_self.$store.commit("article/set_pplist",pplist); 
					_self.setActive3(pplist);	
										
					_self.$router.push({path:'/main'})
					// setTimeout(function(){
					// 	_self.$router.push({path:'/main'})
					// },500)
				})
		  });
		  return;
	}, 
	setActive3(pplist,setDefault=0)
	{
		  var menuListData=this.$store.state.article.menuList;
		  menuListData=modifyNestedArrayByKeyName(menuListData,"class3","active3",function(node){
				node.class3=""
		  });
		  if(pplist.length>0)
		  {
			  var ival=pplist[pplist.length-1];			  
			  menuListData=modifyNestedArrayById(menuListData,ival.id,function(node){
				node.class3="active3"
			  });
		  }		  
		  this.$store.commit("article/set_menuList",menuListData);		  		  
		  this.$store.commit("article/set_seltMenuItem",pplist[pplist.length-1]);
		  console.log("header2-setActive3----------------menuListData:",menuListData);
		  console.log("header2-setActive3---------------pplist:",pplist[pplist.length-1]);
	},
	
	
	
	  changePic(src){
		  this.homeImgSrc=src;
	  },
	  loginout(){
		  var _self=this;
		  this.$confirm({
			  title: '确定要退出当前账户吗', 
			  centered:true,
			  onOk() {
				var usertoken={token:_self.$store.state.user.token};
				_self.Logout(usertoken).then(res=>{
					//console.log(res);
					if(res.errcode===0)
					{						
						_self.$message.success(res.errmsg);
						setTimeout(function(){						
							_self.$router.push({path:'/login'});//
							this.SetNextLogin(false)
						},1000);
					}
				})
				.catch(error => {
				  _self.$message.error(error || '退出失败');
				});
			  },
			  onCancel() {
				console.log('取消');
			  },
			  class: 'loginout',
		 });
	  },
	  showMsgBox(){
		  this.$confirm({
			  title: '暂无消息...', 
			  onOk() {
				console.log('确定');
			  },
			  onCancel() {
				console.log('取消');
			  },
			  class: 'test',
		  });
		return;  
	  },
  },
};
</script>

<style lang="scss" scoped> 
.header{
	padding: 0 20px; padding-left: 29px; padding-right: 36px;
	background:unset;position: relative;z-index: 100; height: 80px;
	.ant-row{
		background: unset;
		.logo-div{ 
			padding-top: 25px; 
			img{width: 32px; max-height:32px;max-width:32px; float: left;margin-right:10px;}
			h1{ font-size: 24px; line-height: 28px;float: left;margin-top: 2px; font-weight: 600; letter-spacing:0px;color:rgba(23, 71, 137, 1)}
			button{ float:left; background: unset; border: unset;width: 24px; height: 24px;min-width: 24px; margin-top: 5px;margin-left: 24px;}
			button img{ width: 24px; height: 24px; margin-right: 0px;}
		}
		
		.searchfrom-div{ 
			overflow:hidden;
			ul{
				display: block;
				position: relative;
				margin: 0px auto;
				margin-top: 16px; 
				height: 48px; 
				width: 100%;max-width:607px; float: left;
				border-radius: 40px; border: solid  2px rgba(255, 255, 255, 0.85);
				background-color: rgba(255, 255, 255, 0.65);
				opacity: 0;
				transition:all,0.3s;
				li{ 
					float: left; position: relative;opacity: 0;transition:all 0.2s;
				}
				.search-tip{ 
					display: block; width: 64px;height: 100%; line-height: 42px; 
					text-align: center; font-size: 16px;  font-weight:550;margin-left: 12px; 
					img{ max-width: 24px; max-height: 24px; float: left; margin-right:8px; margin-top: 10px;}
				}
				.search-input{ 
					display: block; width: 83%;height: 100%; text-align: center;  position: relative; margin-left: 21px;
					.input-txt{
						height: 42px; font-size: 16px;line-height: 42px; background: unset; 
						position: absolute;top: 0px;z-index: 0;left: 0px; 		
						border: unset!important; background: unset!important;width: 95%;
					} 
					.input-txt:focus{ border: unset;outline: none;}
					.icon-close{ font-size: 12px;color: #333; position: absolute; z-index: 1;right: 10px;top: 15px; display: none;}
					.active{display: block;cursor: pointer;}
				}
			}
		}
		.searchfrom-div.active ul{
			transition:all 0.1s;
			opacity: 1;
			li{
				opacity: 1;transition:all 0.3s;
			}
			
		}
		.userinfrom-div{
			position: absolute;right: 0px;top: 0px;
			ul{
				display: block;
				position: relative;
				width: 100%; 
				float:right; 
				margin-top: 10px;
				margin-right: -10px;
				img{ max-width: 24px; max-height: 24px;}
				li{ display:inline-flex; text-align: right;width: 25%; vertical-align: middle; position: relative;} 
				li:nth-child(1){ height: 24px;}
				.search-li{  
					span{
						color:rgb(31, 110, 238) ; font-size: 16px; font-weight:400; 
						display: block;
						height: 25px; width: 64px;
						line-height: 25px;
						position: absolute;
						top:0px;right: 20px;
					}
				} 
				li:nth-child(4){
					.ant-avatar{width: 40px; height: 40px; }
				}
			}
			.userinform-imgdiv{
				position: relative;
				.user-avatar{ border: solid 1px rgba(31, 110, 238, 1);}
				dl{
					display: flow-root;
					position: absolute;top: 48px;right: -1000px;min-width:128px;min-height: 48px; margin: 0px auto;
					background-color: rgba(255, 255, 255, 1); box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
					border-radius: 8px;  
					transition:all 0.3s;
					dd{
						width: auto;
						text-align: center; 
						font-size: 16px; margin: 0px auto;
						padding: 12px;  padding-right: 16px;
					}
					dd i{ font-size: 24px; float: left; margin-left: 0px; margin-right: 8px;}
					dd span{ float: left; height: 24px; line-height: 24px;}
				}
			}
			.userinform-imgdiv.active dl{ opacity: 1;right: 10px;z-index: 200; transition:all 0.3s;}
		}
	}
}
 
.userinform-imgdiv .tcbk{display: none; background-color: rgba(0, 0, 0, 0.01); width: 100vw; height: 100vh; position:fixed;z-index: 100;left: 0px;top: 0px;}
.userinform-imgdiv.active .tcbk{ display: block;}
 
@media (max-width:420px){
	.header .ant-row .userinfrom-div ul img{ max-width:16px!important; max-height: 16px!important;}
}
@media (max-width:820px){
	.header{
		.ant-row{
			.userinfrom-div ul .search-li img{ right: 10px;}
		}
	} 
	
}
@media (min-width:821px)and(max-width:1024px)
{ 
	.header{
		.ant-row{
			.userinfrom-div ul .search-li img{ right: 15px;}
		}
	}
}
</style>
<style> 
	.loginout .ant-modal{width: 330px !important;;height:164px!important;}
	.loginout .ant-modal-body{ padding: 0px !important;}
	.loginout .ant-modal-confirm-body { 
		text-align: center; padding-top:36px; padding-bottom: 40px; font-size: 16px; font-weight: 400; 
		border-bottom: solid 1px #eee; line-height: 24px;
		}
	.loginout .ant-modal-confirm-body i{ display: none; } 
	.loginout.ant-modal-confirm .ant-modal-confirm-btns{ margin: 0px auto!important;width: 100%;}
	.loginout.ant-modal-confirm .ant-modal-confirm-btns button{
		width: 50%; height: auto; background-color: unset; border: unset; border-right: solid 1px #eee;
		padding-top: 21px; padding-bottom:21px; margin:0px auto;color:rgba(25, 26, 26, 1); font-size: 16px; line-height: 22px; font-weight: 400;
	}
	.loginout.ant-modal-confirm .ant-modal-confirm-btns button:last-child{ border: unset;color: rgba(31, 110, 238, 1); }
</style>